module.exports = __webpack_public_path__ + "img/arrow.348dca5f.svg";